import { render, staticRenderFns } from "./ViewDialog.vue?vue&type=template&id=1397cefe&"
import script from "./ViewDialog.vue?vue&type=script&lang=ts&"
export * from "./ViewDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports